import { render, staticRenderFns } from "./CreateLooseAppointmentView.vue?vue&type=template&id=5e53e070&scoped=true&"
import script from "./CreateLooseAppointmentView.vue?vue&type=script&lang=ts&"
export * from "./CreateLooseAppointmentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53e070",
  null
  
)

export default component.exports